// extracted by mini-css-extract-plugin
export default {"title":"LoginForm_title__4nIwD","editor":"LoginForm_editor__S3J5J","brand":"LoginForm_brand__MQ-6V"};